import templateUrl from './detectorEventTable.tpl.html';

export const detectorEventTable = [
    'eventModal',
    'alertingService',
    'alertTypeService',
    'detectorPriorityService',
    '$location',
    '$q',
    'dashboardV2Service',
    'featureEnabled',
    function (
        eventModal,
        alertingService,
        alertTypeService,
        detectorPriorityService,
        $location,
        $q,
        dashboardV2Service,
        featureEnabled
    ) {
        return {
            scope: {
                detectorEvents: '=',
                pinTime: '=',
                createNewEvent: '=',
                hasEventsTab: '=',
            },
            restrict: 'E',
            templateUrl,
            link: function (scope) {
                function getDashboardNavigationContext() {
                    const currentPath = $location.path();
                    if (
                        !currentPath.startsWith('/dashboard/') &&
                        !currentPath.startsWith('/page/')
                    ) {
                        return $q.resolve(undefined);
                    }

                    const dashboardUrl = alertingService.getDashboardNavigationUrl(
                        currentPath,
                        $location.search()
                    );

                    // /page/:groupId is a dashboard group id, not the individual dashboard
                    // the chart belongs to, so it can't be resolved to a dashboard name here.
                    const dashboardId = currentPath.startsWith('/dashboard/')
                        ? currentPath.split('/')[2]
                        : undefined;

                    if (!dashboardId) {
                        return $q.resolve(
                            alertingService.createAlertDetailsNavigationContext({ dashboardUrl })
                        );
                    }

                    return dashboardV2Service.get(dashboardId).then(
                        (dashboard) =>
                            alertingService.createAlertDetailsNavigationContext({
                                dashboardName: dashboard?.name || dashboard?.sf_dashboard,
                                dashboardUrl,
                            }),
                        () => alertingService.createAlertDetailsNavigationContext({ dashboardUrl })
                    );
                }

                scope.showEventDetails = function (event) {
                    if (
                        featureEnabled('o11yAIITPageDefault') &&
                        event?.metadata?.sf_eventCategory === 'ALERT' &&
                        event?.id
                    ) {
                        getDashboardNavigationContext().then((navigationContext) => {
                            alertingService.navigateToAlertDetails(event.id, navigationContext);
                        });
                        return;
                    }

                    eventModal(event);
                };

                scope.getAlertClass = function (severity) {
                    return detectorPriorityService.getAlertClassBySeverity(severity);
                };

                scope.getDisplayText = function (state) {
                    return alertTypeService.getDisplayFor(state);
                };

                scope.isClearingEvent = function (state) {
                    return alertTypeService.isClearingEvent(state);
                };
            },
        };
    },
];
